
export default class SerializeClass {

    static getSerializedData(target) {
        let resultant = [];
        for (let i = 0; i < target.length; i++) {
            resultant.push({ key: Object.keys(target[i])[0], value: target[i][Object.keys(target[i])[0]] })
        }
        return JSON.stringify(resultant);
    }
}